import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';

const WorksheetTitleInput: InputWithoutSource = ({ input }) => <GenericInput label={input.name} input={input} />;

WorksheetTitleInput.meta = {
    inputType: InputModel.name
};

export default observer(WorksheetTitleInput);
